<template>
  <div>
    <card>
      <el-collapse v-model="activeNames" @change="handleChange" accordion>
        <el-collapse-item v-for="(item, index) in mainNotice"
                            :key="item.infoType"
                          :title="item.roleName"
                          :name="item.infoType">
          <div>
            <el-row>
              <el-col :span="24">
                <el-form class="form-horizontal" ref="ruleForm" label-width="6  0px">
                  <el-form-item label="공지노출" prop="name" style="margin-bottom: 0px">
                    <el-checkbox v-model="item.show"></el-checkbox>
                  </el-form-item>
                  <el-form-item label="첨부파일" prop="upload">
                    <el-upload
                      class="upload-demo"
                      :ref="item.infoType"
                      action="/api/settings/info/upload"
                      :headers="header"
                      :data="getFormParam"
                      :on-remove="handleRemove"
                      :on-preview="handlePreview"
                      :limit="1"
                      :on-success="handleSuccess"
                      :on-change="onChange"
                      :auto-upload="false"
                      :file-list="item.fileName === undefined ? [] : [{name: item.fileName, url: item.filePath}]">
                      <el-button slot="trigger" size="small" type="primary">첨부파일 선택</el-button>
                    </el-upload>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <vue-editor v-model="item.infoHtml" :editorToolbar="customToolbar"></vue-editor>
              </el-col>
              <el-col :span="24" style="margin-top: 10px">
                <div class="pull-right">
                  <el-button type="primary" icon="el-icon-plus" v-on:click="setInfo(item)">내용저장</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </card>
  </div>
</template>

<script>
  import Vue from 'vue'

  import {VueEditor} from "vue2-editor";
  import {Form, FormItem, Button, Row, Col, Checkbox, Collapse, CollapseItem, Upload} from 'element-ui'
  import MainInfoProxy from "../../../../proxies/MainInfoProxy";
  import {mapState} from "vuex";

  Vue.use(Checkbox)
  Vue.use(Button)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Form)
  Vue.use(FormItem)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  Vue.use(Upload)

  export default {
    name: "SettingsInfo",
    components: {
      VueEditor
    },
    created: function () {
      this.$store.dispatch('common/setMenuTitle', "기본 안내 관리");
      this.getMainNotice();
    },
    computed: {
      getFormParam: function () {
        return this.mainInfo;
      }
    },
    methods: {
      getMainNotice() {
        new MainInfoProxy()
          .getMainNotice()
          .then((response) => {
            this.mainNotice = response.notices;
          });
      },
      handleRemove(file, fileList) {
        this.$refs[this.activeNames][0].clearFiles();
      },
      handlePreview(file) {
        location.href = "/api/settings/info/" + this.activeNames + "/download?authorization=" + $cookies.get('id_token');
      },
      checkFile(item) {
        let check = false;
        if(this.$refs[this.activeNames][0].uploadFiles.length > 0 && this.fileChange){
          this.mainInfo.infoType = item.infoType;
          this.mainInfo.show = item.show;
          this.mainInfo.infoHtml = item.infoHtml;
          this.$refs[this.activeNames][0].submit();
          check = true;
        }
        return check;
      },
      setInfo(item) {
        if (confirm("기본안내를 저장하시겠습니까?")) {
          if (!this.checkFile(item)) {
            if(this.$refs[this.activeNames][0].uploadFiles.length === 0){
              item.fileName = null;
              item.filePath = null;
            }
            new MainInfoProxy()
              .create(item)
              .then((response) => {
                if (response.header.returnCode === "OK") {
                  alert("저장되었습니다.");
                } else {
                  alert(response.header.resultMessages);
                }
              });
          }
        }
      },
      handleChange(val) {
      },
      handleSuccess(response, files, fileList) {
        if (response.header.returnCode === "OK") {
          this.$refs[this.activeNames][0].clearFiles();
          alert("저장되었습니다.");
          this.getMainNotice();
        } else {
          alert(response.header.resultMessages);
        }
      },
      onChange(file, fileList) {
        this.fileChange = true;
      }
    },
    data() {
      return {
        fileChange : false,
        header: {
          Authorization:$cookies.get('id_token')
        },
        activeNames: 'ADMIN',
        mainNotice: [],
        mainInfo: {
          infoType: "basic",
          show: false,
          infoHtml: "",
        },
        customToolbar: [[{'header': [1, 2, 3, 4, 5, 6, false]}], ["bold", "italic", "underline", 'strike'], [{list: "ordered"}, {list: "bullet"}], ["image"], ['clean']]
      }
    }
  }
</script>

<style>
  #editor {
    height: 400px;
  }
</style>
